import React from 'react'
import './ServerError.scss'

const ServerError = ({ customMessage, level }) => {
  const levelClassVal = level || 'default'
  return (
    <span className={`server-error error-level--${levelClassVal}`}>
      {customMessage
        ? customMessage
        : `An error has occurred. Please try this action again at another time!`}
    </span>
  )
}

export default ServerError
